import React, { useEffect, useRef, useState } from 'react'; 
import './PricingCard.css';
import GradientButton from '../ui/GradientButton/GradientButton';

interface Benefit {
  benefit: string;
  description: string;
}

interface PricingCardProps {
  image: string;
  price: string;
  duration: string;
  benefits: Benefit[];
  mostPopular?: boolean;
}

const PricingCard: React.FC<PricingCardProps> = ({
  image,
  price,
  duration,
  benefits,
  mostPopular,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target); // Stop observing after it appears
        }
      },
      { threshold: 0.3 } // Trigger when 30% of the card is visible
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }
 
  }, []);

  return (
    <div
      ref={cardRef}
      className={`pricing-card ${isVisible ? 'fade-in' : ''}`} // Apply fade-in class
    >
      <div
        className="pricing-card-image"
        style={{ backgroundImage: `url(${image})` }}
      >
        {mostPopular && <span className="most-popular-label">Most Popular</span>}
        <div className="pricing-card-price">
          <h2 className="price">${price}</h2>
          <p className="duration">{duration}</p>
        </div>
      </div>
      <div className="pricing-card-content">
        <ul className="benefits-list">
          {benefits.map((item, index) => (
            <li key={index}>
              <p className="benefit">{item.benefit}</p>
              <p className="benefit-description">{item.description}</p>
            </li>
          ))}
        </ul>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
        <GradientButton
  onClick={() => window.open('https://buy.stripe.com/test_aEUaI55zk2AK7HafYY', '_blank')}
>
  Buy Now
</GradientButton>
        </div>
      </div>
    </div>
  );
};

export default PricingCard;
